export default "__VITE_ASSET__1DjIwAmy__"